import React from 'react';
import './Terms.css';
import BackButton from './backbutton/BackButton';

const Privacy = () => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <BackButton />
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. Information We Collect</h2>
          <p>
            When you use Clubsta, we may collect the following categories of information:
          </p>
          <ul>
            <li><strong>Club Information:</strong> When submitting or updating a running club, we collect the club’s name, location, schedule, description, and organizer details.</li>
            <li><strong>Contact Information:</strong> If you submit a club or use forms on our site, we may collect your email address and other basic contact details for verification and communication.</li>
            <li><strong>Usage Data:</strong> We collect information on how users interact with the platform, including pages visited, features used, and navigation behavior.</li>
            <li><strong>Technical Information:</strong> We collect anonymized data about the devices and browsers used to access the service, including IP address, operating system, and session metadata.</li>
            <li><strong>Cookies & Preferences:</strong> We use cookies and local storage to store session information, analytics, and user preferences.</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>We use the information collected for the following purposes:</p>
          <ul>
            <li>To publish and display running club listings to help users find local communities.</li>
            <li>To verify the accuracy and legitimacy of submitted club information.</li>
            <li>To communicate with club organizers and respond to user inquiries.</li>
            <li>To analyze site performance, improve user experience, and optimize navigation.</li>
            <li>To personalize features and recommend clubs based on location and preferences.</li>
            <li>To protect the integrity and security of our platform and user data.</li>
          </ul>
        </section>

        <section>
          <h2>3. Information Sharing</h2>
          <p>
            We do not sell, trade, or rent your personal information. Public club details (e.g. name, location, and schedule) are displayed for user discovery. Personal contact details submitted via forms are used strictly for communication and verification and are not shared or published.
          </p>
        </section>

        <section>
          <h2>4. Data Security</h2>
          <p>
            We take data security seriously. Clubsta implements technical and organizational safeguards designed to protect your information from unauthorized access, misuse, or disclosure. While no internet transmission is ever fully secure, we continuously monitor and maintain our systems to mitigate risks.
          </p>
        </section>

        <section>
          <h2>5. Cookies and Tracking</h2>
          <p>
            Clubsta uses cookies and local storage to manage sessions, remember user preferences, and improve the site’s performance. These technologies also help us understand how users interact with the site so we can refine and enhance the experience. You can manage cookies through your browser settings.
          </p>
        </section>

        <section>
          <h2>6. Third-Party Services</h2>
          <p>
            Some features on Clubsta involve integrations with third-party services such as mapping tools, embedded media, and forms. These services may collect or process data according to their own privacy practices. We encourage users to review their policies when interacting with third-party elements on our site.
          </p>
        </section>

        <section>
          <h2>7. Your Rights</h2>
          <p>Under applicable laws, including the California Consumer Privacy Act (CCPA), you may have the following rights:</p>
          <ul>
            <li>The right to access and receive a copy of personal information we hold about you.</li>
            <li>The right to request corrections to inaccurate or outdated information.</li>
            <li>The right to request deletion of your personal information where legally permitted.</li>
            <li>The right to opt out of communications that are not essential to the service.</li>
            <li>The right to contact us with any data protection concerns or complaints.</li>
          </ul>
        </section>

        <section>
          <h2>8. Children’s Privacy</h2>
          <p>
            Clubsta is not intended for use by individuals under the age of 18. We do not knowingly collect personal information from anyone under 18 years of age. If we become aware that personal data has been submitted by a user under 18, we will take steps to delete such information promptly.
          </p>
        </section>

        <section>
          <h2>9. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy to reflect changes to our practices or for legal and operational reasons. When we do, we will update the "Last updated" date above. We recommend checking this page periodically to stay informed.
          </p>
        </section>

        <section>
          <h2>10. Data Retention</h2>
          <p>
            We retain information for as long as it is necessary to provide the service, improve our platform, and comply with legal obligations. Club listings may remain published until removed by request or deemed outdated. Personal information is retained only for as long as necessary to support the purposes outlined above.
          </p>
        </section>

        <section>
          <h2>11. Contact Us</h2>
          <p>
            If you have questions or concerns about this Privacy Policy or how your data is handled, please reach out to us:
          </p>
          <p>
            Email: luke.furnell@clubsta.co<br />
            Website: www.clubsta.co
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
